// extracted by mini-css-extract-plugin
export var toastSlideUp = "copy_color_message-module--toastSlideUp--524ac";
export var wrapper = "copy_color_message-module--wrapper--9f199";